export const MODULE_NAME = 'SHOWCASE_AUTOMATION'

export interface State {}
